module.exports = __webpack_public_path__ + "img/ethereum.2113fb63.svg";